import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Col from '@loggi/ui/components/col';
import ViewContainer from '@loggi/ui/components/view-container';
import InputLabel from '@loggi/ui/components/input-label';
import inputSelectRange from '@loggi/ui/components/utils/dom/input-select-range';
import { SIZES } from '@loggi/ui/components/utils/sizes';
import styles from './index.scss';

class Textarea extends React.Component {
  static displayName = 'Textarea';
  static propTypes = {
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    resize: PropTypes.bool,
    hasFocus: PropTypes.bool,
    helperText: PropTypes.string,
    label: PropTypes.string,
    focus: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        start: PropTypes.number,
        end: PropTypes.number
      })
    ]),
    value: PropTypes.string,
    maxLength: PropTypes.number,
    textProps: PropTypes.object,
    size: PropTypes.oneOf(SIZES),
    labelComponent: PropTypes.object,
    labelComponentProps: PropTypes.object
  };
  static defaultProps = {
    resize: false,
    hasFocus: false,
    textProps: {},
    labelComponent: null,
    labelComponentProps: null
  };

  constructor(props, context) {
    super(props, context);

    this._handleOnChange = this._handleOnChange.bind(this);
    this._handleOnFocus = this._handleOnFocus.bind(this);
    this._handleOnBlur = this._handleOnBlur.bind(this);
    this._focus = this._focus.bind(this);

    this.state = {
      value: props.value || '',
      hasFocus: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.value === nextState.value) {
      return true;
    }

    const { value } = nextProps;
    this.setState({ value });

    return false;
  }

  componentDidUpdate() {
    this._focus();
  }

  getInput() {
    return this.refs.textarea;
  }

  getValue() {
    return this.state.value;
  }

  _handleOnChange(e) {
    e.preventDefault();

    let value = e.target.value;

    this.setState({ value });
    const { onChange } = this.props;
    if (onChange) {
      onChange(value);
    }
  }

  _handleOnFocus(e) {
    const { onFocus } = this.props;

    if (onFocus) {
      onFocus(e);
    }
  }

  _handleOnBlur(e) {
    const { onBlur } = this.props;

    if (onBlur) {
      onBlur(e);
    }
  }

  _focus() {
    const textarea = this.getInput();
    const focus = this.props.hasFocus || this.props.focus;

    if (focus && textarea !== null) {
      if (typeof focus === 'object') {
        let start = focus.start;
        let end = focus.end;

        if (start < 0 || end < 0) {
          textarea.focus();
        } else {
          inputSelectRange(textarea, start, end);
        }
      } else {
        textarea.focus();
      }
    }
  }

  componentDidMount() {
    this._focus();
  }

  render() {
    const {
      textProps,
      label,
      size,
      helperText,
      labelComponent,
      labelComponentProps
    } = this.props;
    const classesTextarea = classNames(
      'form-control',
      styles.text,
      this.props.className
    );
    const style = {
      ...this.props.style,
      resize: !this.props.resize && 'none'
    };

    return (
      <ViewContainer fluid>
        <Col size={12}>
          <InputLabel
            size={size}
            text={label}
            helperText={helperText}
            component={labelComponent}
            componentProps={labelComponentProps}
          />
        </Col>
        <Col size={12}>
          <textarea
            ref="textarea"
            style={style}
            className={classesTextarea}
            onChange={this._handleOnChange}
            onFocus={this._handleOnFocus}
            onBlur={this._handleOnBlur}
            value={this.getValue()}
            placeholder={this.props.placeholder}
            maxLength={this.props.maxLength || null}
            {...textProps}
          />
        </Col>
      </ViewContainer>
    );
  }
}

export default Textarea;
